import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "overflow-hidden",
  ref: "headerRef"
}
const _hoisted_2 = { class: "w-full table-fixed whitespace-normal" }
const _hoisted_3 = {
  class: "z-10",
  style: {"background":"#FEF7E5"}
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "text-base" }
const _hoisted_7 = {
  class: "overflow-auto",
  ref: "bodyRef"
}
const _hoisted_8 = {
  key: 1,
  class: "max-w-full row-bg h-40 flex items-center justify-center text-gray-500",
  style: {"background":"#FEF7E5"}
}
const _hoisted_9 = { class: "w-full table-fixed whitespace-normal" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-left" }, " Total ", -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([
      'max-w-full whitespace-nowrap overflow-hidden',
      { 'rounded-lg': !_ctx.square }
    ])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("colgroup", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column) => {
              return (_openBlock(), _createElementBlock("col", {
                key: column.id,
                style: _normalizeStyle({ width: `${column?.width}px` })
              }, null, 4))
            }), 128))
          ]),
          _createElementVNode("thead", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column, columnIndex) => {
              return (_openBlock(), _createElementBlock("th", {
                key: `header-${column.id}`,
                class: _normalizeClass([
              'p-6 headingShadow border-b border-d8ceb5',
              column.className,
              _ctx.getHorizontalStickyClass(columnIndex),
              _ctx.isColumnStuck ? 'isSticky' : '',
              column.sortKey ? 'cursor-pointer' : '',
              _ctx.currentSortColumn === column.id && _ctx.currentSortDirection
                ? 'text-red-400'
                : 'text-gray-800 dark:text-gray-100'
            ]),
                ref: _ctx.setHeaderRef(columnIndex),
                onClick: ($event: any) => (_ctx.handleSort(column.id))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([
                'flex',
                column.align === 'right' ? 'justify-end' : 'justify-start'
              ])
                }, [
                  (column.Header)
                    ? _renderSlot(_ctx.$slots, column.Header, _normalizeProps(_mergeProps({ key: 0 }, column)))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("h5", _hoisted_6, _toDisplayString(column.name), 1)
                      ])),
                  (
                  _ctx.currentSortColumn === column.id &&
                    _ctx.currentSortDirection === 'asc'
                )
                    ? (_openBlock(), _createBlock(_component_BalIcon, {
                        key: 2,
                        name: "arrow-up",
                        size: "sm",
                        class: "ml-1 flex items-center"
                      }))
                    : _createCommentVNode("", true),
                  (
                  _ctx.currentSortColumn === column.id &&
                    _ctx.currentSortDirection === 'desc'
                )
                    ? (_openBlock(), _createBlock(_component_BalIcon, {
                        key: 3,
                        name: "arrow-down",
                        size: "sm",
                        class: "ml-1 flex items-center"
                      }))
                    : _createCommentVNode("", true)
                ], 2)
              ], 10, _hoisted_4))
            }), 128))
          ])
        ])
      ], 512),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
              key: 0,
              class: _normalizeClass([_ctx.skeletonClass, 'min-w-full']),
              square: "",
              style: _normalizeStyle({ width: `${_ctx.placeholderBlockWidth}px` })
            }, null, 8, ["class", "style"]))
          : _createCommentVNode("", true),
        (!_ctx.isLoading && !_ctx.tableData.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.noResultsLabel || _ctx.$t('noResults')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("table", _hoisted_9, [
          _createElementVNode("colgroup", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column) => {
              return (_openBlock(), _createElementBlock("col", {
                key: column.id,
                style: _normalizeStyle({ width: `${column?.width}px` })
              }, null, 4))
            }), 128))
          ]),
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column, columnIndex) => {
              return (_openBlock(), _createElementBlock("td", {
                key: column.id,
                class: _normalizeClass([
              column.align === 'right' ? 'text-left' : 'text-right',
              _ctx.getHorizontalStickyClass(columnIndex),
              _ctx.isColumnStuck ? 'isSticky' : '',
              'bg-white dark:bg-gray-850 p-0 m-0 h-0'
            ])
              }, null, 2))
            }), 128))
          ]),
          (!_ctx.isLoading && _ctx.tableData.length)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (dataItem, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `tableRow-${index}`,
                    onClick: ($event: any) => (_ctx.handleRowClick(dataItem)),
                    class: _normalizeClass(['z-10 row-bg group', { 'cursor-pointer': _ctx.onRowClick }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column, columnIndex) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: column.id,
                        class: _normalizeClass([
                column.align === 'right' ? 'text-left' : 'text-right',
                _ctx.getHorizontalStickyClass(columnIndex),
                _ctx.isColumnStuck ? 'isSticky' : ''
              ])
                      }, [
                        (_ctx.link)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: {
                  name: _ctx.link.to,
                  params: _ctx.link.getParams(dataItem)
                }
                            }, {
                              default: _withCtx(() => [
                                (column.Cell)
                                  ? _renderSlot(_ctx.$slots, column.Cell, _normalizeProps(_mergeProps({ key: 0 }, dataItem)))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: _normalizeClass(
                    _ctx.compact([
                      'px-6 py-4',
                      column.align === 'right' ? 'text-right' : 'text-left',
                      column.cellClassName
                    ])
                  )
                                    }, _toDisplayString(typeof column.accessor === 'string'
                      ? dataItem[column.accessor]
                      : column.accessor(dataItem)), 3))
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (column.Cell)
                                ? _renderSlot(_ctx.$slots, column.Cell, _normalizeProps(_mergeProps({ key: 0 }, dataItem)))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(
                    _ctx.compact([
                      'px-6 py-4',
                      column.align === 'right' ? 'text-right' : 'text-left',
                      column.cellClassName
                    ])
                  )
                                  }, _toDisplayString(typeof column.accessor === 'string'
                      ? dataItem[column.accessor]
                      : column.accessor(dataItem)), 3))
                            ], 64))
                      ], 2))
                    }), 128))
                  ], 10, _hoisted_11))
                }), 128)),
                (_ctx.shouldRenderTotals)
                  ? (_openBlock(), _createElementBlock("tr", {
                      key: 0,
                      class: _normalizeClass([
              'bg-white z-10 row-bg group',
              { 'cursor-pointer': _ctx.onRowClick }
            ])
                    }, [
                      _createElementVNode("td", {
                        class: _normalizeClass([
                _ctx.getHorizontalStickyClass(0),
                _ctx.isColumnStuck ? 'isSticky' : '',
                'text-left p-6 bg-white dark:bg-gray-850 border-t border-d8ceb5 align-top'
              ])
                      }, _hoisted_13, 2),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tail(_ctx.filteredColumns), (column, columnIndex) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: column.id,
                          class: _normalizeClass([
                column.align === 'right' ? 'text-left' : 'text-right',
                _ctx.getHorizontalStickyClass(columnIndex + 1),
                _ctx.isColumnStuck ? 'isSticky' : '',
                'p-6 bg-white dark:bg-gray-850 border-t border-d8ceb5'
              ])
                        }, [
                          (column.totalsCell)
                            ? _renderSlot(_ctx.$slots, column.totalsCell, { key: 0 })
                            : _createCommentVNode("", true)
                        ], 2))
                      }), 128))
                    ], 2))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 512)
    ], 2),
    (_ctx.isPaginated && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "bal-table-pagination-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (!_ctx.isLoadingMore && _ctx.$emit('loadMore')))
        }, [
          (_ctx.isLoadingMore)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.$t('loading')), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.$t('loadMore')) + " ", 1),
                _createVNode(_component_BalIcon, {
                  name: "chevron-down",
                  size: "sm",
                  class: "ml-2"
                })
              ], 64))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}